var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.955,
    height: 19.029,
    viewBox: "0 0 21.955 19.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M37.069,56.2l-.007,0L17.526,48.1a1.078,1.078,0,0,0-1.016.1,1.128,1.128,0,0,0-.51.942V54.32a1.1,1.1,0,0,0,.893,1.078l10.655,1.97a.183.183,0,0,1,0,.36L16.893,59.7A1.1,1.1,0,0,0,16,60.775v5.183a1.078,1.078,0,0,0,.484.9,1.1,1.1,0,0,0,.6.183,1.123,1.123,0,0,0,.435-.088L37.06,58.9l.009,0a1.464,1.464,0,0,0,0-2.69Z",
    transform: "translate(-16 -48.013)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhiteIcon);
export default __webpack_public_path__ + "static/media/send-white-icon.1ca52015e5d3df5af38edbc3d70841d5.svg";
export { ForwardRef as ReactComponent };